import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryStrip() {
  return (
    <section className="container-x py-12 md:py-16">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="text-xs font-medium tracking-widest text-primary-600">栏目一览</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">从哪个角度开聊？</h2>
        </div>
        <Link
          to="/section/zongmen"
          className="hidden items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700 sm:flex"
        >
          查看全部讨论
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {categories.map((c) => (
          <Link
            key={c.slug}
            to={`/section/${c.slug}`}
            className="group flex flex-col rounded-xl border border-background-200/70 bg-background-100/60 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:bg-background-50 hover:shadow-soft"
          >
            <span className={`flex h-11 w-11 items-center justify-center rounded-lg bg-background-50 text-xl ${c.accent}`}>
              <i className={c.icon}></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{c.name}</h3>
            <p className="mt-1.5 flex-1 text-xs leading-relaxed text-foreground-500">{c.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
              进入栏目
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}